export default __webpack_public_path__ + "static/media/ImgIcon.75a1fe8a.svg";